import { useFormik } from 'formik'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import InputPassword from '../../Inputs/InputPassword/InputPassword'
import Typography from '../../Typography/Typography'
import FormInputsContainer from '../FormInputsContainer/FormInputsContainer'
import FormLayout from '../FormLayout/FormLayout'
import FormPasswordValidation from '../FormPasswordValidation/FormPasswordValidation'
import hocChangeForgottenPassword from './hocFormChangePassword'

import './FormChangePassword.scss'

const FormChangePassword = ({ changePassword, email, loading, sectionRef }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
        },
        validationSchema: Yup.object({
            oldPassword: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            newPassword: Yup.string()
                .matches(
                    /^((?=.*\d)(?=.*[a-z,A-Z]).{8,16}$)/,
                    intl.formatMessage({ id: 'forms.changePassword.invalidPassword' })
                )
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'password does not match email',
                    intl.formatMessage({ id: 'forms.register.passwordMatchesEmail' }),
                    function (value) {
                        return email !== value
                    }
                ),
            confirmNewPassword: Yup.string()
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'newPasswords-match',
                    intl.formatMessage({ id: 'forms.changePassword.passwordsMustMatch' }),
                    function (value) {
                        return this.parent.newPassword === value
                    }
                ),
        }),
        onSubmit: (values) => {
            changePassword(values)
            formik.handleReset()
        },
    })

    return (
        <Container fluid className="change-password d-flex flex-column" ref={sectionRef}>
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.changePassword.title' })}</Typography>
            <FormLayout
                size={'lg'}
                onSubmit={formik.handleSubmit}
                className={`change-password--form d-flex flex-column`}
            >
                <FormInputsContainer>
                    <InputPassword
                        id={'oldPassword'}
                        name={'oldPassword'}
                        {...formik.getFieldProps('oldPassword')}
                        error={formik?.errors?.oldPassword}
                        touched={formik?.touched?.oldPassword}
                        label={intl.formatMessage({ id: 'forms.changePassword.oldPasswordLabel' })}
                        placeholder={intl.formatMessage({ id: 'forms.changePassword.oldPasswordPlaceholder' })}
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                    />
                    <div className="d-none d-md-block w-100" />
                </FormInputsContainer>

                <FormInputsContainer>
                    <Container fluid className="d-flex flex-column">
                        <InputPassword
                            name={'newPassword'}
                            id={'newPassword'}
                            {...formik.getFieldProps('newPassword')}
                            error={formik?.errors?.newPassword}
                            touched={formik?.touched?.newPassword}
                            label={intl.formatMessage({ id: 'forms.changePassword.newPasswordLabel' })}
                            placeholder={intl.formatMessage({ id: 'forms.changePassword.newPasswordPlaceholder' })}
                            onBlur={formik?.handleBlur}
                            disabled={loading}
                        />
                        <FormPasswordValidation
                            value={formik?.values?.newPassword}
                            touched={formik?.touched?.newPassword}
                            email={email}
                        />
                    </Container>
                    <InputPassword
                        name={'confirmNewPassword'}
                        id={'confirmNewPassword'}
                        error={formik?.errors?.confirmNewPassword}
                        touched={formik?.touched?.confirmNewPassword}
                        {...formik.getFieldProps('confirmNewPassword')}
                        label={intl.formatMessage({ id: 'forms.changePassword.confirmationPasswordLabel' })}
                        placeholder={intl.formatMessage({
                            id: 'forms.changePassword.confirmationPasswordPlaceholder',
                        })}
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                    />
                </FormInputsContainer>

                <Container fluid>
                    <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                        {intl.formatMessage({
                            id: 'buttons.buttonSave',
                        })}
                    </ButtonCinestar>
                </Container>
            </FormLayout>
        </Container>
    )
}

export default hocChangeForgottenPassword(FormChangePassword)
